(function (root, factory) {
  var api = factory();

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.HUDEFPaddleFinder = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  var PRIORITY_LABELS = {
    power: 'power',
    spin: 'spin',
    control: 'control',
    comfort: 'comfort',
  };

  var SHAPE_LABELS = {
    elongated: 'Elongated shape',
    wide: 'Wide-body shape',
    hybrid: 'Hybrid shape',
    balanced: 'Balanced shape',
  };

  var FEEL_LABELS = {
    fast: 'Fast swing',
    stable: 'Stable feel',
    'arm-friendly': 'Arm-friendly feel',
    balanced: 'Balanced feel',
  };

  function priceBand(price) {
    var value = Number(price) || 0;

    if (value < 100) {
      return 'under100';
    }

    if (value <= 150) {
      return '100to150';
    }

    return 'over150';
  }

  function uniqueReasons(reasons) {
    return reasons.filter(function (reason, index) {
      return reason && reasons.indexOf(reason) === index;
    }).slice(0, 3);
  }

  function canAdvance(question, answers) {
    return Boolean(question && answers && answers[question]);
  }

  function fitSummary(candidate) {
    var profile = (candidate && candidate.profile) || {};
    var summary = [];

    if (SHAPE_LABELS[profile.shape]) {
      summary.push(SHAPE_LABELS[profile.shape]);
    }

    if (FEEL_LABELS[profile.feel]) {
      summary.push(FEEL_LABELS[profile.feel]);
    }

    return summary.join(' - ') || 'Balanced paddle profile';
  }

  function scoreCandidate(candidate, answers) {
    var profile = candidate.profile || {};
    var reasons = [];
    var score = 0;
    var priority = PRIORITY_LABELS[answers.priority];

    if (priority && profile[priority] != null) {
      score += Number(profile[priority]) * 3;

      if (Number(profile[priority]) >= 4 && candidate.reasons && candidate.reasons[priority]) {
        reasons.push(candidate.reasons[priority]);
      }
    }

    if (answers.shape && answers.shape !== 'unsure') {
      if (profile.shape === answers.shape) {
        score += 4;
        reasons.push((candidate.reasons && candidate.reasons.shape) || 'The paddle shape matches what you selected.');
      } else if (answers.shape === 'balanced' && profile.shape === 'hybrid') {
        score += 2;
        reasons.push((candidate.reasons && candidate.reasons.shape) || 'The hybrid shape offers a balanced starting point.');
      }
    }

    if (answers.feel && answers.feel !== 'unsure' && profile.feel === answers.feel) {
      score += 4;
      reasons.push((candidate.reasons && candidate.reasons.feel) || 'The listed feel is aligned with your preference.');
    }

    if (answers.budget && priceBand(candidate.price) === answers.budget) {
      score += 3;
      reasons.push('The current store price fits your selected range.');
    }

    if (answers.level && profile.level && profile.level.indexOf(answers.level) !== -1) {
      score += 2;
    }

    return {
      candidate: candidate,
      score: score,
      reasons: uniqueReasons(reasons.concat(candidate.bestFor || '')),
      tradeoff: candidate.tradeoff || 'Review the current product details before ordering.',
      budgetBand: priceBand(candidate.price),
    };
  }

  function rankCandidates(candidates, answers) {
    var ranked = (candidates || []).map(function (candidate, index) {
      var result = scoreCandidate(candidate, answers || {});
      result.index = index;
      return result;
    }).sort(function (left, right) {
      return right.score - left.score || left.index - right.index;
    });

    return {
      primary: ranked[0] || null,
      alternatives: ranked.slice(1, 3),
      ranked: ranked,
    };
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function track(eventName, payload) {
    if (!window.dataLayer) {
      return;
    }

    window.dataLayer.push({
      event: eventName,
      paddle_finder: payload || {},
    });
  }

  function init(rootElement) {
    var root = rootElement || document.querySelector('[data-hudef-paddle-finder]');

    if (!root) {
      return;
    }

    var dataNode = root.querySelector('[data-hudef-paddle-finder-data]');
    var candidates = [];
    var answers = {};
    var currentStep = 1;
    var totalSteps = root.querySelectorAll('[data-screen="question"]').length;
    var progress = root.querySelector('[data-progress-fill]');
    var progressLabel = root.querySelector('[data-progress-label]');
    var progressTopic = root.querySelector('[data-progress-topic]');
    var progressWrap = root.querySelector('[data-progress]');
    var resultScreen = root.querySelector('[data-screen="result"]');
    var questionScreens = Array.prototype.slice.call(root.querySelectorAll('[data-screen="question"]'));

    try {
      candidates = JSON.parse(dataNode ? dataNode.textContent : '[]');
    } catch (error) {
      candidates = [];
    }

    function showScreen(step) {
      currentStep = step;
      questionScreens.forEach(function (screen, index) {
        var active = index + 1 === step;
        screen.hidden = !active;
        screen.classList.toggle('is-active', active);
      });

      if (progress) {
        progress.style.width = Math.round((step / totalSteps) * 100) + '%';
      }

      if (progressLabel) {
        progressLabel.textContent = 'Question ' + step + ' of ' + totalSteps;
      }

      if (progressTopic) {
        var activeScreen = questionScreens[step - 1];
        progressTopic.textContent = activeScreen ? activeScreen.getAttribute('data-step-label') || '' : '';
      }

      root.querySelectorAll('[data-progress-step]').forEach(function (dot, index) {
        dot.classList.toggle('is-active', index + 1 === step);
        dot.classList.toggle('is-complete', index + 1 < step);
      });
    }

    function updateOptionState(question) {
      root.querySelectorAll('[data-question="' + question + '"]').forEach(function (option) {
        var selected = option.getAttribute('data-value') === answers[question];
        option.classList.toggle('is-selected', selected);
        option.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      root.querySelectorAll('[data-question-name="' + question + '"]').forEach(function (button) {
        button.disabled = !canAdvance(question, answers);
      });
    }

    function renderProduct(result, primary) {
      if (!result || !result.candidate) {
        return '<p class="hudef-paddle-finder-page__empty">Choose a few preferences and we will match you with a HUDEF paddle from the current lineup.</p>';
      }

      var candidate = result.candidate;
      var reasons = result.reasons.map(function (reason) {
        return '<li>' + escapeHtml(reason) + '</li>';
      }).join('');
      var image = candidate.image ? '<img src="' + escapeHtml(candidate.image) + '" alt="' + escapeHtml(candidate.imageAlt || candidate.title) + '" loading="eager">' : '';
      var title = primary ? 'Best match' : 'Also worth comparing';
      var productUrl = candidate.url && candidate.url.indexOf('/products/') === 0 ? candidate.url : '#';

      return '<article class="hudef-paddle-finder-page__result-card' + (primary ? ' hudef-paddle-finder-page__result-card--primary' : '') + '">' +
        '<div class="hudef-paddle-finder-page__result-media">' + image + '</div>' +
        '<div class="hudef-paddle-finder-page__result-content">' +
          '<p class="hudef-paddle-finder-page__result-kicker">' + escapeHtml(title) + '</p>' +
          '<h3>' + escapeHtml(candidate.title) + '</h3>' +
          '<p class="hudef-paddle-finder-page__result-price">' + escapeHtml(candidate.priceLabel) + '</p>' +
          '<p class="hudef-paddle-finder-page__result-fit">' + escapeHtml(fitSummary(candidate)) + '</p>' +
          '<ul class="hudef-paddle-finder-page__reasons">' + reasons + '</ul>' +
          '<p class="hudef-paddle-finder-page__tradeoff"><strong>Good to know:</strong> ' + escapeHtml(result.tradeoff) + '</p>' +
          '<a class="hudef-paddle-finder-page__cta" href="' + escapeHtml(productUrl) + '">View paddle details <span aria-hidden="true">&rarr;</span></a>' +
        '</div>' +
      '</article>';
    }

    function renderResults() {
      var result = rankCandidates(candidates, answers);
      var primaryTarget = root.querySelector('[data-result-primary]');
      var alternativesTarget = root.querySelector('[data-result-alternatives]');

      if (primaryTarget) {
        primaryTarget.innerHTML = result.primary ? renderProduct(result.primary, true) : renderProduct(null, true);
      }

      if (alternativesTarget) {
        alternativesTarget.innerHTML = result.alternatives.map(function (alternative) {
          return renderProduct(alternative, false);
        }).join('');
      }

      if (progressWrap) {
        progressWrap.hidden = true;
      }

      questionScreens.forEach(function (screen) {
        screen.hidden = true;
      });

      if (resultScreen) {
        resultScreen.hidden = false;
        resultScreen.classList.add('is-active');
      }

      track('paddle_finder_complete', {
        product_handle: result.primary && result.primary.candidate.handle,
        score: result.primary && result.primary.score,
      });

      root.querySelector('[data-result-heading]')?.focus();
    }

    root.addEventListener('click', function (event) {
      var option = event.target.closest('[data-question]');
      var nextButton = event.target.closest('[data-next-step]');
      var restartButton = event.target.closest('[data-restart]');

      if (option && root.contains(option)) {
        var question = option.getAttribute('data-question');
        answers[question] = option.getAttribute('data-value');
        updateOptionState(question);
        track('paddle_finder_answer', { question: question, answer: answers[question] });
        return;
      }

      if (nextButton && root.contains(nextButton)) {
        var questionName = nextButton.getAttribute('data-question-name');
        if (!answers[questionName]) {
          return;
        }

        var nextStep = Number(nextButton.getAttribute('data-next-step'));
        if (nextStep > totalSteps) {
          renderResults();
        } else {
          showScreen(nextStep);
        }
        return;
      }

      if (restartButton && root.contains(restartButton)) {
        answers = {};
        root.querySelectorAll('[data-question]').forEach(function (answer) {
          answer.classList.remove('is-selected');
          answer.setAttribute('aria-pressed', 'false');
        });
        root.querySelectorAll('[data-next-step]').forEach(function (button) {
          button.disabled = true;
        });
        if (progressWrap) {
          progressWrap.hidden = false;
        }
        if (resultScreen) {
          resultScreen.hidden = true;
          resultScreen.classList.remove('is-active');
        }
        showScreen(1);
      }
    });

    root.querySelectorAll('[data-next-step]').forEach(function (button) {
      button.disabled = true;
    });
    showScreen(1);
    track('paddle_finder_start');
  }

  return {
    init: init,
    canAdvance: canAdvance,
    fitSummary: fitSummary,
    priceBand: priceBand,
    rankCandidates: rankCandidates,
    scoreCandidate: scoreCandidate,
  };
});

if (typeof document !== 'undefined') {
  document.addEventListener('DOMContentLoaded', function () {
    if (window.HUDEFPaddleFinder) {
      window.HUDEFPaddleFinder.init();
    }
  });
}
